<div class="addon-card">
  <div class="addon-card__media">
    <img class="addon-card__image" [src]="banner.imageUrl" alt="" />
  </div>

  <div *ngIf="!editMode" class="addon-card__meta">
    <div class="meta-row">
      <span class="meta-label">{{ "addons.banners.name" | translate }}</span>
      <span class="meta-value">{{ banner.name }}</span>
    </div>
    <div class="meta-row">
      <span class="meta-label">{{ "addons.banners.url" | translate }}</span>
      <span class="meta-value">{{ banner.url }}</span>
    </div>
    <div class="meta-row">
      <span class="meta-label">{{ "addons.banners.utm" | translate }}</span>
      <span class="meta-value">{{ banner.utm }}</span>
    </div>
    <div class="meta-row" *ngIf="banner.imageWidth">
      <span class="meta-label">{{ "imageWidth" | translate }}</span>
      <span class="meta-value">{{ banner.imageWidth }} px</span>
    </div>
    <div class="meta-row" *ngIf="banner.modifiedAt">
      <span class="meta-label">{{ "modifiedAt" | translate }}</span>
      <span class="meta-value">{{
        banner.modifiedAt | localizedDate: "medium"
      }}</span>
    </div>
    <div class="meta-row">
      <span class="meta-label">{{ "addons.usage.label" | translate }}</span>
      <span class="meta-value" *ngIf="!banner.isUsed">{{
        "addons.usage.notUsed" | translate
      }}</span>
      <div class="addon-usage" *ngIf="banner.isUsed">
        <span class="meta-value">{{
          "addons.usage.usedInCount"
            | translate: { count: (banner.usedInSignatures?.length || 0) }
        }}</span>
        <ul class="addon-usage__list" *ngIf="banner.usedInSignatures?.length">
          <li *ngFor="let signature of banner.usedInSignatures">
            <a [routerLink]="['/signatures', signature.templateId, 'edit']">{{
              signature.name
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <form
    [formGroup]="form"
    class="addon-card__form"
    (ngSubmit)="changeBanner()"
    *ngIf="editMode"
  >
    <div class="meta-row" *ngIf="banner.modifiedAt">
      <span class="meta-label">{{ "modifiedAt" | translate }}</span>
      <span class="meta-value">{{
        banner.modifiedAt | localizedDate: "medium"
      }}</span>
    </div>
    <mat-form-field appearance="outline">
      <app-image-uploader
        [allowedFileExtensions]="[
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/webp',
          'image/svg+xml'
        ]"
        wrongTypeMessage="{{ 'addons.banners.wrongType' | translate }}"
        description="{{ 'addons.banners.description' | translate }}"
        additionalDescription="{{
          'addons.banners.additionalDescription' | translate
        }}"
        [previewImageStyles]="
          imageService.getImageStyle(form.get('imageWidth').value)
        "
        (onFileChange)="fileChange($event)"
        (onFileRemove)="removeFile()"
      ></app-image-uploader>
      <input matInput formControlName="file" hidden="hidden" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "imageWidth" | translate }}</mat-label>
      <input matInput formControlName="imageWidth" type="number" min="0" />
      <span matSuffix>px</span>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "addons.banners.name" | translate }}</mat-label>
      <input
        matInput
        formControlName="name"
        type="text"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="form.hasError('required', ['name'])">{{
        "fieldRequired" | translate
      }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "addons.banners.url" | translate }}</mat-label>
      <input
        matInput
        formControlName="url"
        type="text"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="form.hasError('required', ['url'])">{{
        "fieldRequired" | translate
      }}</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ "addons.banners.utm" | translate }}</mat-label>
      <input
        matInput
        formControlName="utm"
        type="text"
        [errorStateMatcher]="errorStateMatcher"
      />
      <mat-error *ngIf="form.hasError('required', ['utm'])">{{
        "fieldRequired" | translate
      }}</mat-error>
    </mat-form-field>
  </form>

  <div class="addon-card__actions">
    <button
      type="button"
      class="action-btn"
      *ngIf="editMode"
      (click)="cancelEditBanner()"
      [attr.aria-label]="'cancel' | translate"
    >
      <mat-icon>cancel</mat-icon>
      {{ "cancel" | translate }}
    </button>
    <button
      type="button"
      class="action-btn"
      *ngIf="editMode"
      (click)="changeBanner()"
      [attr.aria-label]="'save' | translate"
    >
      <mat-icon>save</mat-icon>
      {{ "save" | translate }}
    </button>
    <button
      type="button"
      class="action-btn"
      *ngIf="!editMode"
      (click)="changeEditMode()"
      [attr.aria-label]="'edit' | translate"
    >
      <mat-icon>edit</mat-icon>
      {{ "edit" | translate }}
    </button>
    <button
      type="button"
      class="action-btn"
      *ngIf="!editMode"
      (click)="copyBannerToClipboard()"
      [attr.aria-label]="'copyToClipboard' | translate"
    >
      <mat-icon>content_copy</mat-icon>
      {{ "copyToClipboard" | translate }}
    </button>
    <button
      type="button"
      class="action-btn action-btn--danger"
      *ngIf="!editMode && !banner.isUsed"
      (click)="removeBanner(banner.addonId)"
      [attr.aria-label]="'delete' | translate"
    >
      <mat-icon>delete_outline</mat-icon>
      {{ "delete" | translate }}
    </button>
  </div>
</div>
